import { axios } from "../axios";
import { BaseResponse, Status } from "../Shared";
import { UpdateNotificationsRequest } from "./Types";

export const updateNotifications = async (req: UpdateNotificationsRequest): Promise<BaseResponse> => {
  return axios
    .request<BaseResponse>({
      method: "patch",
      url: "notifications",
      data: req,
    })
    .then(() => ({
      status: Status.Success,
    }))
    .catch((error) => ({
      status: Status.Error,
      errors: error.errors || [],
    }));
};
